import { styled } from "@mui/material/styles";
import { Paper, Fab, Box } from "@mui/material";

export const RootContainer = styled('div')(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(2),
  position: 'relative',
}));

export const GoBackFab = styled(Fab)(({ theme }) => ({
  position: "fixed",
  top: theme.spacing(8),
  right: theme.spacing(0),
  zIndex: theme.zIndex.appBar - 1,
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  '&:has(> div > .MuiBox-root)': {
    maxHeight: '500px',
    overflow: 'auto'
  }
}));

export const FormContainer = styled(Box)(({ theme }) => ({
  width: '100%',
}));

export const TableContainer = styled('div')(({ theme }) => ({
  width: '100%',
  minHeight: 450,
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  '& > *': {
    width: 'auto',
    minWidth: '100%',
  }
}));

export const ControlsContainer = styled('div')(({ theme }) => ({
  width: '100%',
  minHeight: 450,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  overflowY: 'auto',
  '& > *': {
    width: '100%',
    minWidth: 'auto',
    marginBottom: theme.spacing(1),
    boxShadow: 'none',
    border: 'none',
  }
}));

export const SectionTitle = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  fontWeight: 500,
  width: '100%',
})); 